import React, { useEffect, useState } from "react";
import NavigoDashboardUtils, {
  formatDigitisationCost,
} from "../services/DigitiseDashboardUtils";
import EventService from "../../../../../service/event/EventService";
import FontIcons from "react-md/lib/FontIcons";
import moment from "moment";
import { Card, SelectField, TextField } from "material-ui";
import { Col, Row } from "react-flexbox-grid";
import { Autocomplete, Button, SelectionControlGroup } from "react-md";
import { exit } from "process";
import PatientsService from "../../../../ops/modules/patients/service/PatientsService";
import { Modal } from "@material-ui/core";
import UpdateTrackingService from "../../../../ops/modules/patients/modules/new-bridge/components/Update_tracking/service/UpdateTrackingService";

function DigitiseReport(props) {
  const navigoDashboardUtils = new NavigoDashboardUtils();
  const patientService = new PatientsService();
  const updatetrackingservice = new UpdateTrackingService();
  const [documentData, setDocumentData] = useState({});
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState("");
  const [dataTables, setDataTables] = useState({});
  const [labPagesData, setLabPagesData] = useState([]);
  const [pageIndex, setPageIndex] = useState(0);
  const [newItems, setNewItems] = useState([]);
  const [rerenderFlag, setRerenderFlag] = useState(true);
  const [labTestData, setLabTestData] = useState([]);
  const [subLabTestData, setSubLabTestData] = useState([]);
  const [selectedLabTestForSubTest, setSelectedLabTestForSubTest] =
    useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedLabTests, setSelectedLabTests] = useState([]);
  const [saveAsDraft, setSaveAsDraft] = useState(false);
  const [markAsReviewed, setMarkAsReviewed] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [selectedRemoveIdx, setSelectedRemoveIdx] = useState(null);
  useEffect(() => {
    if (documentData?.labtestDigitisationDataDraft) {
      setLabPagesData(documentData.labtestDigitisationDataDraft);
    }
  }, [documentData]);
  const isDisabled = documentData.status === 1;

  const pages = labPagesData || [];
  const currentPageItems = pages[pageIndex]?.items || [];

  const findNextIncompletePage = (currentIndex) => {
    const draftPages = documentData?.labtestDigitisationDataDraft || [];
    let shouldJumpToLast = false;

    for (let i = currentIndex + 1; i < draftPages.length; i++) {
      const page = draftPages[i];

      // 1️⃣ Skip missing/invalid pages BUT trigger last-page jump
      if (!page || !Array.isArray(page.items) || page.items.length === 0) {
        shouldJumpToLast = true;
        continue;
      }

      // 2️⃣ STOP if any item has isDigitised === false
      const hasExplicitIncomplete = page.items.some(
        (item) => item.isDigitised === false
      );
      if (hasExplicitIncomplete) return i;

      // 3️⃣ Track pages with missing isDigitised
      const hasMissingDigitised = page.items.some(
        (item) => item.isDigitised === undefined
      );
      if (hasMissingDigitised) {
        shouldJumpToLast = true;
      }
    }

    // 4️⃣ If any page was empty OR missing isDigitised → go to LAST PAGE
    if (shouldJumpToLast) {
      return draftPages.length - 1;
    }

    return null;
  };

  const handleNext = () => {
    if (documentData.status !== 1) {
      handleSave(3, pageIndex + 1);
    }
    if (pageIndex < pages.length - 1) {
      setPageIndex((prev) => prev + 1);
    }
  };

  const handleArrowNext = () => {
    const nextIncomplete = findNextIncompletePage(pageIndex);

    if (nextIncomplete !== null) {
      setPageIndex(nextIncomplete);
    } else {
      console.log("No more incomplete pages ahead.");
    }
  };

  const findPrevIncompletePage = (currentIndex) => {
    const draftPages = documentData?.labtestDigitisationDataDraft || [];

    let foundIncomplete = null;

    for (let i = currentIndex - 1; i >= 0; i--) {
      const page = draftPages[i];

      // Skip empty pages → treat as fully digitised
      if (!page || !Array.isArray(page.items) || page.items.length === 0) {
        continue; // SKIP, do NOT stop
      }

      // STOP if explicit incomplete found
      const hasExplicitIncomplete = page.items.some(
        (item) => item.isDigitised === false
      );

      if (hasExplicitIncomplete) {
        foundIncomplete = i;
        break;
      }

      // Missing isDigitised → treat as digitised, SKIP
      const hasMissingFlag = page.items.some(
        (item) => item.isDigitised === undefined
      );

      if (hasMissingFlag) {
        continue; // SKIP
      }

      // All items digitised → SKIP
      const allDigitised = page.items.every(
        (item) => item.isDigitised === true
      );

      if (allDigitised) {
        continue; // SKIP
      }
    }

    // If nothing incomplete behind → return FIRST page
    if (foundIncomplete === null && currentIndex > 0) {
      return 0;
    }

    return foundIncomplete;
  };

  const handleArrowPrev = () => {
    const prevIdx = findPrevIncompletePage(pageIndex);

    if (prevIdx !== null) {
      setPageIndex(prevIdx);
    }
  };

  const handleBack = () => {
    if (documentData.status !== 1) {
      handleSave(3, pageIndex + 1);
    }
    if (pageIndex > 0) {
      setPageIndex((prev) => prev - 1);
    }
  };

  useEffect(() => {
    generateDocumentToken();
    getDataTables();
  }, []);

  const generateDocumentToken = () => {
    patientService.getAndSaveDocumentToken(
      (response) => {
        localStorage.setItem("zy.bridge.doc.token", JSON.stringify(response));
        setToken(response.token);
      },
      (error) => {}
    );
  };
  const getDataTables = () => {
    let onResponse = (data) => {
      setDataTables(data);
    };
    let onError = (error) => {
      EventService.emit("showError", { message: error.message });
    };

    navigoDashboardUtils.getDataTables(onResponse, onError);
  };

  useEffect(() => {
    if (props) {
      getDocumentData(props.data);
    }
  }, [props]);

  useEffect(() => {
    if (saveAsDraft) {
      getDocumentData(props.data);
      setSaveAsDraft(false);
    }
  }, [saveAsDraft]);

  useEffect(() => {
    if (markAsReviewed) {
      exitPage();
    }
  }, [markAsReviewed]);

  const getDocumentData = (id) => {
    navigoDashboardUtils.getDocumentData(
      id,
      (res) => {
        setDocumentData(res);
      },
      (err) => {
        EventService.emit("showError", {
          message: `Error: ${err?.message}`,
        });
      }
    );
  };

  const exitPage = () => {
    props.setView(0);
  };

  const handleSave = (status, pageNum) => {
    const updatedDocumentData = {
      ...documentData,
      status: status,
      labtestDigitisationDataDraft: labPagesData.map((page) => ({
        pageNum: page.pageNum,
        testDate: page.testDate,
        items: page.items.map((item) => ({
          labTest: item.labTest
            ? {
                label: item.labTest.label || "",
                value: item.labTest.value || "",
                abbreviatedName: item.labTest.abbreviatedName || "",
              }
            : null,
          subTest: {
            subTestCode: {
              label: item.subTest?.subTestCode?.label || "",
              value: item.subTest?.subTestCode?.value || "",
            },
            subTest: item.subTest?.subTestCode?.value || "",
            loincCode: item.subTest?.loincCode || "",
            value: item.subTest?.value || "",
            valueUOM: item.subTest?.valueUOM || "",
            range: item.subTest?.range || "",
            referenceRange: item.subTest?.referenceRange || "",
            description: item.subTest?.description || "",
          },
          isDigitised: !!(
            item.labTest?.label?.trim() && item.labTest?.value?.trim()
          ),
          aiDigitisationId: item.aiDigitisationId,
        })),
      })),
    };
    navigoDashboardUtils.digitiseReport(
      documentData?.documentId,
      pageNum,
      updatedDocumentData,
      (res) => {
        if (status == 3) {
          setSaveAsDraft(true);
        }
        setConfirmModal(false);
        if (status == 1) {
          setMarkAsReviewed(true);
          EventService.emit("showError", {
            message: `Document has been reviewed successfully.`,
          });
        }
      },
      (err) => {
        console.error("Error saving lab test data:", err);
        EventService.emit("showError", {
          message: `Error: ${err?.message || "Failed to save lab test data"}`,
        });
      }
    );
  };

  const baseUrl = documentData?.documentUrl?.split("?")[0];

  const fullUrl = `${baseUrl}?token=${encodeURIComponent(token)}`;

  const fire = (text, index) => {
    if (text.length > 1) {
      getLabTest(text);
    }
  };

  const getLabTest = (text) => {
    updatetrackingservice.getLabTest(
      text,
      (data) => {
        if (data) setLabTestData(data);
        setSubLabTestData([]);
      },
      (error) => {
        console.error("Lab Test Fetch Failed", error);
      }
    );
  };

  const OnSelect = (e, index) => {
    const selectedLabTest = labTestData.find((item) => item.value === e);
    const selectedLabel = selectedLabTest?.label;

    setSelectedLabTests((prev) => {
      const updated = [...prev];
      updated[index] = { value: e, index };
      return updated;
    });

    setLabPagesData((prev) => {
      const updated = [...prev];
      if (!updated[pageIndex]) updated[pageIndex] = { items: [] };

      const existingItem = updated[pageIndex].items[index] || {};

      updated[pageIndex].items[index] = {
        ...existingItem,
        labTest: { value: e, label: selectedLabel },
        subTest: {
          ...existingItem.subTest,
          subTestCode: { label: "", value: "" },
          loincCode: "",
        },
      };

      return updated;
    });

    setRerenderFlag(false);
    setTimeout(() => setRerenderFlag(true), 0);
  };

  const getSubLabTests = (text, labTestId, idx) => {
    updatetrackingservice.getSubTest(
      labTestId.value,
      text,
      (data) => {
        const updated = [...subLabTestData];
        updated[idx] = data;
        setSubLabTestData(updated);
      },
      (error) => {
        console.error("SubTest fetch error", error);
      }
    );
  };

  const handleSubTestSelect = (selectedValue, pageIndex, idx) => {
    const selectedSubTest = subLabTestData[idx]?.find(
      (item) => item.value === selectedValue
    );

    const selectedLabel = selectedSubTest?.label || "";
    const loincCode = selectedSubTest?.loincCode || "";

    setLabPagesData((prev) => {
      const updated = [...prev];
      if (!updated[pageIndex]) updated[pageIndex] = { items: [] };

      updated[pageIndex].items[idx] = {
        ...(updated[pageIndex].items[idx] || {}),
        subTest: {
          ...(updated[pageIndex].items[idx]?.subTest || {}),
          subTestCode: {
            value: selectedValue,
            label: selectedLabel,
          },
          subTestName: selectedLabel,
        },
      };
      return updated;
    });
    if (selectedValue && selectedLabTests[idx]?.value) {
      updatetrackingservice.getSubTestData(
        selectedLabTests[idx].value,
        selectedValue,
        (data) => {
          setLabPagesData((prev) => {
            const updated = [...prev];
            if (!updated[pageIndex]) updated[pageIndex] = { items: [] };

            updated[pageIndex].items[idx] = {
              ...(updated[pageIndex].items[idx] || {}),
              subTest: {
                ...(updated[pageIndex].items[idx]?.subTest || {}),
                loincCode: data.loincName || loincCode,
              },
            };
            return updated;
          });
        },
        (error) => {
          console.error("Error fetching sub test data:", error);
          EventService.emit("showError", {
            message: "Failed to load LOINC data for this test",
          });
        }
      );
    } else {
      setLabPagesData((prev) => {
        const updated = [...prev];
        if (!updated[pageIndex]) updated[pageIndex] = { items: [] };

        updated[pageIndex].items[idx] = {
          ...(updated[pageIndex].items[idx] || {}),
          subTest: {
            ...(updated[pageIndex].items[idx]?.subTest || {}),
            loincCode: loincCode,
          },
        };
        return updated;
      });
    }
  };

  const handleFieldChange = (idx, fieldPath, value) => {
    setLabPagesData((prev) => {
      const updated = [...prev];
      if (fieldPath === "testDate") {
        if (!updated[pageIndex]) updated[pageIndex] = { items: [] };
        updated[pageIndex].testDate = moment
          .utc(value, "YYYY-MM-DD")
          .toISOString();
        return updated;
      }
      if (!updated[pageIndex]) updated[pageIndex] = { items: [] };

      const newItem = { ...(updated[pageIndex].items[idx] || {}) };

      const keys = fieldPath.split(".");
      let current = newItem;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) current[key] = {};
        current = current[key];
      }

      current[keys[keys.length - 1]] = value;

      updated[pageIndex].items[idx] = newItem;
      return updated;
    });
  };

  const handleRemoveItem = (idx) => {
    setLabPagesData((prev) => {
      const updated = [...prev];
      if (updated[pageIndex]?.items) {
        updated[pageIndex].items = updated[pageIndex].items.filter(
          (_, i) => i !== idx
        );
      }
      return updated;
    });
  };
  const getEmptyCardItem = () => ({
    labTest: null, // Important: use null instead of empty object
    testDate: moment().format("YYYY-MM-DD"),
    subTest: {
      subTestCode: null, // Important: use null instead of empty object
      loincCode: "",
      value: "",
      valueUOM: "",
      range: "",
      referenceRange: "",
      description: "",
    },
    isDigitised: true,
  });

  const handleAddNewItem = () => {
    setLabPagesData((prev) => {
      // Create a completely new array for immutability
      const newPages = prev.map((page) => ({
        ...page,
        items: [...page.items], // Shallow copy of items array
      }));

      // Create a brand new empty item
      const newItem = getEmptyCardItem();

      // Initialize page if it doesn't exist
      if (!newPages[pageIndex]) {
        newPages[pageIndex] = {
          pageNum: pageIndex + 1,
          testDate: moment().toISOString(),
          items: [],
        };
      }

      // Add new item at the beginning
      newPages[pageIndex].items.unshift({ ...newItem });

      return newPages;
    });

    // Force a re-render to ensure clean state
    setRerenderFlag((prev) => !prev);
  };

  const documentStatus = [
    { value: 1, name: "Reviewed" },
    { value: 2, name: "Not reviewed" },
    { value: 3, name: "Saved as draft" },
    { value: 4, name: "In progress" },
  ];

  const getStatusLabel = (statusValue) => {
    const match = documentStatus.find((status) => status.value === statusValue);
    return match ? match.name : "Not reviewed";
  };

  // badge for the extraction model. Match by family (qwen / gemini) so a version bump
  // (e.g. qwen3-vl-8b -> qwen3-vl-32b) still labels correctly. Legacy/blank -> Gemini.
  const getModelBadge = (model) => {
    const isQwen = String(model || "")
      .toLowerCase()
      .includes("qwen");
    const m = isQwen
      ? { label: "Qwen", color: "#ef7c01", bg: "rgba(239,124,1,0.1)" }
      : { label: "Gemini", color: "rgba(48,197,63,1)", bg: "rgba(48,197,63,0.1)" };
    return (
      <span
        style={{
          color: m.color,
          backgroundColor: m.bg,
          borderRadius: "10px",
          padding: "2px 10px",
          fontWeight: 700,
          fontSize: "12px",
        }}
      >
        {m.label}
      </span>
    );
  };
  const handleAddCardAtIndex = (insertIdx) => {
    setLabPagesData((prev) => {
      const newState = JSON.parse(JSON.stringify(prev));

      // Initialize page if it doesn't exist
      if (!newState[pageIndex]) {
        newState[pageIndex] = {
          pageNum: pageIndex + 1,
          testDate: moment().toISOString(),
          items: [],
        };
      }

      // Create a brand new empty item
      const newItem = {
        ...getEmptyCardItem(),
        // Ensure testDate is properly formatted
        testDate: moment().format("YYYY-MM-DD"),
      };

      // Insert at specified position
      newState[pageIndex].items.splice(insertIdx, 0, newItem);

      return newState;
    });

    // Force a re-render to ensure clean state
    setRerenderFlag((prev) => !prev);
  };

  return (
    <>
      <div className="digitise-container">
        <div style={{ marginBottom: "24px" }}>
          {" "}
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="navigo-module-view">
                <div className="navigo-module-heading-with-back-button">
                  <div
                    className="navigo-module-back-btn"
                    onClick={() => {
                      exitPage();
                    }}
                  >
                    <FontIcons style={{ fontSize: "36px", marginTop: "2px" }}>
                      arrow_back
                    </FontIcons>
                  </div>
                  <h1>{`Digitised report`}</h1>
                </div>
                {documentData.status != 1 && (
                  <div className="navigo-module-buttons-container">
                    <div className="navigo-module-buttons-right-alignment">
                      <Button
                        raised
                        disabled={loading}
                        className={"navigo-module-button-save-enabled"}
                        onClick={() => {
                          handleSave(3);
                          EventService.emit("showError", {
                            message: `Document has been saved as draft.`,
                          });
                        }}
                      >
                        {"Save as draft"}
                      </Button>

                      <Button
                        raised
                        disabled={loading}
                        className="navigo-module-button-save-enabled"
                        onClick={() => {
                          setConfirmModal(true);
                        }}
                      >
                        {"Mark as reviewed"}
                      </Button>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>

        {documentData?.id && (
          <div className="digitise-fields-wrapper">
            <div className="digitise-field">
              <label className="digitise-label">Patient ID</label>
              <div className="digitise-value">{documentData?.patientId}</div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">Document ID</label>
              <div className="digitise-value">{documentData?.documentId}</div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">Status</label>
              <div className="digitise-value">
                {getStatusLabel(documentData.status)}
              </div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">Model</label>
              <div className="digitise-value">
                {getModelBadge(documentData?.digitisationModel)}
              </div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">Digitisation cost</label>
              <div className="digitise-value">
                {formatDigitisationCost(documentData?.digitisationCostInr) ||
                  "-"}
              </div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">
                No. of parameters in document
              </label>
              <div className="digitise-value">
                {documentData?.digitisedParamCount}
              </div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">
                No. of parameters digitised
              </label>
              <div className="digitise-value">
                {documentData.mappedParamCount}
              </div>
            </div>

            <div className="digitise-field">
              <label className="digitise-label">Digitisation date</label>
              <div className="digitise-value">
                {documentData.digitisationDate &&
                documentData.digitisationDate !== "0001-01-01T00:00:00Z"
                  ? moment
                      .utc(documentData.digitisationDate)
                      .format("DD-MM-YYYY")
                  : "-"}
              </div>
            </div>
          </div>
        )}

        <div className="comparison-box">
          <div className="comparison-header">
            <h2>Comparison view</h2>
            <div className="pagination-controls">
              <button
                onClick={handleArrowPrev}
                disabled={pageIndex === 0}
                className="text-blue-600 font-medium disabled:opacity-50"
              >
                &lt;
              </button>

              <button
                onClick={handleBack}
                disabled={pageIndex === 0}
                className="text-blue-600 font-medium disabled:opacity-50"
              >
                ← Previous page
              </button>
              <span>
                <strong>{pageIndex + 1}</strong> / {pages.length}
              </span>
              <button
                onClick={handleNext}
                disabled={pageIndex === pages.length - 1}
                className="text-blue-600 font-medium disabled:opacity-50"
              >
                Next page →
              </button>

              <button
                onClick={handleArrowNext}
                disabled={pageIndex === pages.length - 1}
                className="text-blue-600 font-medium disabled:opacity-50"
              >
                &gt;
              </button>
            </div>
          </div>

          <div className="digitise-frame-wrapper">
            <div className="digitise-frame-left">
              <div className="digitise-frame-title">Lab report</div>
              <iframe
                key={pageIndex}
                src={`${fullUrl}#page=${pageIndex + 1}`}
                title="Lab Report"
                className="digitise-lab-iframe"
              />
            </div>

            <div className="digitise-frame-right">
              {documentData.status != 1 && (
                <div className="digitise-frame-title">
                  Digitised report
                  <button onClick={handleAddNewItem} className="addNewButton">
                    + Add New
                  </button>
                </div>
              )}
              {currentPageItems.length > 0 ? (
                <div className="space-y-6" key={pageIndex}>
                  {currentPageItems.map((item, idx) => (
                    <div
                      key={item.pageNum}
                      id={pageIndex}
                      className={`digitised-card ${
                        !item.isDigitised ? "undigitised" : ""
                      }`}
                    >
                      {!item.isDigitised && (
                        <div className="digitised-card-value error-text">
                          We couldn't digitise this parameter
                        </div>
                      )}

                      {documentData.status != 1 && (
                        <button
                          type="button"
                          className="remove-button"
                          onClick={() => {
                            setSelectedRemoveIdx(idx);
                            setShowRemoveModal(true);
                          }}
                        >
                          -
                        </button>
                      )}

                      <div className="card-grid">
                        <div>
                          <div className="digitised-card-label">Lab Test</div>
                          <Autocomplete
                            key={`lab-${pageIndex}-${idx}-${rerenderFlag}`}
                            name={"labTest" + idx}
                            disabled={isDisabled}
                            className="autocomplete-no-border"
                            id={"labTest" + idx}
                            // defaultValue={item?.labTest?.label}
                            placeholder={
                              item.labTest?.label
                                ? item.labTest?.label
                                : "Select lab test"
                            }
                            data={labTestData}
                            dataLabel="label"
                            dataValue="value"
                            onChange={(e, idx) => {
                              fire(e, idx);
                            }}
                            onAutocomplete={(e) => OnSelect(e, idx)}
                          />
                        </div>

                        <div>
                          <div className="digitised-card-label">Test date</div>
                          <input
                            disabled={isDisabled}
                            type="date"
                            className="digitised-card-value"
                            value={
                              labPagesData?.[pageIndex]?.testDate &&
                              labPagesData[pageIndex].testDate !==
                                "0001-01-01T00:00:00Z"
                                ? moment
                                    .utc(labPagesData[pageIndex].testDate)
                                    .format("YYYY-MM-DD")
                                : ""
                            }
                            max={moment().format("YYYY-MM-DD")}
                            onChange={(e) =>
                              handleFieldChange(idx, "testDate", e.target.value)
                            }
                          />
                        </div>

                        <div>
                          <div className="digitised-card-label">Sub Test</div>

                          <Autocomplete
                            key={`sub-autocomplete-${pageIndex}-${idx}-${rerenderFlag}`}
                            disabled={isDisabled}
                            name="subTestName"
                            className="autocomplete-no-border"
                            id={`subTest-${pageIndex}-${idx}`}
                            placeholder={
                              item.subTest?.subTestCode?.label ||
                              item.subTest?.subTestName ||
                              "Search Sub Test"
                            }
                            // ✅ Only show data if lab test is selected
                            data={
                              labPagesData?.[pageIndex]?.items?.[idx]?.labTest
                                ?.value
                                ? subLabTestData[idx] || []
                                : []
                            }
                            dataLabel="label"
                            dataValue="value"
                            onChange={(text) => {
                              const labTest =
                                labPagesData?.[pageIndex]?.items?.[idx]
                                  ?.labTest;

                              if (text.length > 1 && labTest?.value) {
                                getSubLabTests(text, labTest, idx);
                              } else {
                                // Clear dropdown
                                setSubLabTestData((prev) => {
                                  const updated = [...prev];
                                  updated[idx] = [];
                                  return updated;
                                });
                              }
                            }}
                            onAutocomplete={(e) =>
                              handleSubTestSelect(e, pageIndex, idx)
                            }
                          />
                        </div>

                        <div>
                          <div className="digitised-card-label">LOINC Name</div>
                          <input
                            disabled={isDisabled}
                            className="digitised-card-value"
                            value={item.subTest?.loincCode || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                idx,
                                "subTest.loincCode",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div>
                          <div className="digitised-card-label">Value</div>
                          <input
                            disabled={isDisabled}
                            className="digitised-card-value"
                            value={item.subTest?.value || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                idx,
                                "subTest.value",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        <div>
                          <div className="digitised-card-label">Unit</div>
                          <select
                            disabled={isDisabled}
                            className="digitised-card-value"
                            value={item.subTest?.valueUOM || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                idx,
                                "subTest.valueUOM",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Unit</option>
                            {dataTables?.LAB_TEST_UOM?.map((uom) => (
                              <option key={uom.value} value={uom.value}>
                                {uom.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <div className="digitised-card-label">Range</div>
                          <select
                            disabled={isDisabled}
                            className="digitised-card-value"
                            value={item.subTest?.range || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                idx,
                                "subTest.range",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Range</option>
                            {dataTables?.SUB_LAB_TEST_RANGE?.map(
                              (rangeOption) => (
                                <option
                                  key={rangeOption.value}
                                  value={rangeOption.value}
                                >
                                  {rangeOption.label}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="card-row-full">
                          <div className="digitised-card-label">
                            Reference Range
                          </div>
                          <textarea
                            disabled={isDisabled}
                            className="digitised-card-value auto-resize-textarea"
                            style={{
                              width: "50%",
                              overflow: "hidden",
                              resize: "none",
                              lineHeight: "1.5",
                              minHeight: "60px",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                            ref={(el) => {
                              if (el) {
                                el.style.height = "auto";
                                el.style.height = el.scrollHeight + "px";
                              }
                            }}
                            value={
                              item.subTest?.referenceRange
                                ? item.subTest.referenceRange
                                    .split("\n")
                                    .map((line) =>
                                      line.trim().startsWith("•")
                                        ? line
                                        : `• ${line}`
                                    )
                                    .join("\n")
                                : ""
                            }
                            placeholder="-"
                            onChange={(e) => {
                              const el = e.target;
                              if (!el) return;

                              el.style.height = "auto";
                              el.style.height = el.scrollHeight + "px";

                              const cleaned = el.value
                                .split("\n")
                                .map((line) => line.replace(/^•\s*/, ""))
                                .filter((line) => line !== "")
                                .join("\n");

                              handleFieldChange(
                                idx,
                                "subTest.referenceRange",
                                cleaned
                              );
                            }}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                const textarea = e.target;
                                if (!textarea) return;

                                const { selectionStart, selectionEnd, value } =
                                  textarea;
                                const before = value.slice(0, selectionStart);
                                const after = value.slice(selectionEnd);

                                // Check if we're at the start of a new line
                                const isNewLine =
                                  before.endsWith("\n") || before === "";

                                const newValue = isNewLine
                                  ? `${before}• ${after}`
                                  : `${before}\n• ${after}`;

                                textarea.value = newValue;

                                // Trigger change event manually
                                const event = new Event("input", {
                                  bubbles: true,
                                });
                                textarea.dispatchEvent(event);

                                // Update scroll height
                                textarea.style.height = "auto";
                                textarea.style.height =
                                  textarea.scrollHeight + "px";

                                // Set cursor position safely
                                requestAnimationFrame(() => {
                                  if (textarea) {
                                    const cursorPos = isNewLine
                                      ? before.length + 2
                                      : before.length + 3;
                                    textarea.setSelectionRange(
                                      cursorPos,
                                      cursorPos
                                    );
                                  }
                                });
                              }
                            }}
                          />
                        </div>

                        <div className="card-row-full">
                          <div className="digitised-card-label">
                            Description/Intervention
                          </div>
                          <textarea
                            disabled={isDisabled}
                            className="digitised-card-value"
                            rows={2}
                            value={item.subTest.description || ""}
                            onChange={(e) =>
                              handleFieldChange(
                                idx,
                                "subTest.description",
                                e.target.value
                              )
                            }
                          />
                        </div>
                      </div>
                      {documentData.status != 1 && (
                        <div className="add-card-button-wrapper">
                          <button
                            type="button"
                            className="add-card-button"
                            onClick={() => handleAddCardAtIndex(idx + 1)}
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="digitise-no-doc">No tracking data found</div>
              )}
            </div>
          </div>
        </div>
      </div>
      {confirmModal && (
        <Modal open={confirmModal}>
          <div className="modal-overlay-review">
            <div className="modal-review">
              <h2>{"Confirm to mark it as reviewed"}</h2>
              <p className="info-line">
                *Please be careful — once marked as reviewed, you will no longer
                be able to edit the report or any parameters. You can only view
                the digitised report.
              </p>
              <button
                className="modal-close-button"
                onClick={() => setConfirmModal(false)}
              >
                &times;
              </button>
              <div className="modal-buttons">
                <button
                  className="view-doc-button"
                  onClick={() => setConfirmModal(false)}
                >
                  Back to editing
                </button>
                <button
                  className="confirm-doc-button"
                  style={{ marginRight: "8px" }}
                  onClick={() => handleSave(1)}
                >
                  Mark as Reviewed
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {showRemoveModal && (
        <div className="modal-overlay-review">
          <div className="modal-review">
            <h2>{"Are you sure you want to delete this subtest entry"}</h2>
            <p className="info-line">
              *Please be careful if once confirmed, all entries you made will be
              deleted. To add new entry again, click on ‘+’ button
            </p>
            <button
              className="modal-close-button"
              onClick={() => setShowRemoveModal(false)}
            >
              &times;
            </button>
            <div className="modal-buttons">
              <button
                className="view-doc-button"
                onClick={() => setShowRemoveModal(false)}
              >
                Cancel
              </button>
              <button
                className="confirm-doc-button"
                onClick={() => {
                  handleRemoveItem(selectedRemoveIdx);
                  setShowRemoveModal(false);
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DigitiseReport;
